import { useEffect, useState } from 'react';
import useTrackOpen from '@hooks/use-track-open-hook';
import { useDispatch, useSelector } from 'react-redux';
import { makeSelectCategory } from 'containers/SearchContainer/selectors';
import { sendAJobSetStep } from 'containers/AppContainer/actions';
import { track } from 'lib/sdks/analytics';
import RAQFunnel from 'components/Funnelling/RAQFunnel';
import { JOB_TYPE } from 'lib/sdks/jobs-management/job.constants';
import { JobContextProvider } from 'components/Funnelling/job.context';
import { TradeProvider } from 'components/Funnelling/trade.context';
import useIsMobileScreen from '@hooks/use-is-mobile-screen';
import RAQBanner from './RAQBanner/RAQBanner';
import { type AnsweredQuestion } from 'components/JobRefinement';

export const PostAJobBanner = ({
  defaultToOpen = false,
  location,
  postcode,
  requestId,
  onContactTrades,
}: {
  defaultToOpen?: boolean;
  location: string;
  postcode: string | undefined;
  requestId: string;
  onContactTrades: (
    answer?: AnsweredQuestion,
    skipSummaryScreen?: boolean,
  ) => void;
}) => {
  const dispatch = useDispatch();
  const category = useSelector(makeSelectCategory());
  const [expanded, setExpanded] = useState(defaultToOpen);
  const [disableModalAnimation, setDisableModalAnimation] = useState(false);
  const isMobile = useIsMobileScreen();

  useEffect(() => {
    dispatch(sendAJobSetStep({ step: 'form' }));
  }, [dispatch]);

  useTrackOpen({
    open: expanded,
    onOpen: () => {
      track('inline_send_a_job.open', { resource_type: 'search' });
    },
  });

  const handleOpenRAQ = () => {
    setExpanded(true);
  };

  return (
    <JobContextProvider initialState={{ type: JOB_TYPE.requestAQuote }}>
      {expanded && (
        <TradeProvider initialValue={null}>
          <RAQFunnel
            from="search"
            onDismiss={() => {
              setExpanded(false);
              setDisableModalAnimation(false);
            }}
            categoryId={category.id}
            skills={[]}
            forceStartDateFirst={isMobile}
            searchLocation={location}
            disableAnimation={disableModalAnimation}
          />
        </TradeProvider>
      )}

      <RAQBanner
        setOpen={handleOpenRAQ}
        onContactTrades={onContactTrades}
        searchLocation={location}
        postcode={postcode}
        categoryId={category.id}
        requestId={requestId}
      />
    </JobContextProvider>
  );
};

export default PostAJobBanner;
